import type { AnalyticsAppStore } from '@lib/analytics/events';
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '@lib/constants';

const HOMEPAGE_CAMPAIGN_SOURCE = 'homepage';

// Play Console attributes installs by the utm_ fields in `referrer`; the App
// Store has no equivalent without an App Store Connect provider token.
const GOOGLE_PLAY_HOMEPAGE_REFERRER = encodeURIComponent(
  `utm_source=${HOMEPAGE_CAMPAIGN_SOURCE}&utm_medium=badge`
);

/**
 * Where the homepage's store badges and QR code send people. These stand in
 * for a homepage-tagged AppsFlyer OneLink until marketing issues one
 * (FFH-2818); swapping it in here retags every homepage install at once.
 */
export const HOMEPAGE_APP_STORE_LINKS: Record<AnalyticsAppStore, string> = {
  app_store: APP_STORE_URL,
  google_play: `${GOOGLE_PLAY_URL}&referrer=${GOOGLE_PLAY_HOMEPAGE_REFERRER}`
};

// The device-aware /app redirect, so one code serves both stores.
export const HOMEPAGE_APP_QR_URL = `${process.env.NEXT_PUBLIC_HOSTNAME}/app?utm_source=${HOMEPAGE_CAMPAIGN_SOURCE}&utm_medium=qr`;
